<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">

    <div class="full-width ui basic segment">
      <h1 class="ui block header"> Contact Us </h1>

      <div class="ui basic segment">
        <div class="two column stackable ui grid">
          <div class="column">
            <div class="segment">
              <h4 class="ui block header">
                <i class="marker icon"></i> Address
              </h4>
              <p>Plot 420, Tigris Crescent,</p>
              <p>Off Aguiyi Ironsi Street,</p>
              <p>Maitama, Abuja.</p>
              <p>Nigeria.</p>
              <p>
                <i class="mail icon"></i> cservice@cac.gov.ng</p>
            </div>
          </div>
          <div class="column">
            <div class="segment">
              <h4 class="ui block header">
                <i class="call icon"></i> Telephone
              </h4>
              <h5>Customer Service</h5>
              <p>
                <i class="call icon"></i>Line 1 - <b>08182298971</b></p>
              <p>
                <i class="call icon"></i>Line 2 - <b>08182299016</b></p>

              <p>
              <i class="call icon"></i>Line 3 - <b>09087401599</b></p>
              <p>
                <i class="call icon"></i>Line 4 - <b>09087401598</b></p>
              <p>
                <i class="call icon"></i>Line 5 - <b>09087401600</b></p>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
